import { Size } from '@/types';

export const scaleSize = ({ width, height }: Size, scale: number): Size => ({
  width: Math.abs(width * scale),
  height: Math.abs(height * scale),
  unit: 'mm',
});
